module.exports = __webpack_public_path__ + "media/application/images/pawnbroker_how-it-works-1ce2a917b675b992f5f9df192747652e.png";